/**
* takes an owner-code as number and returns
* an owner-color as string
*
* @param    {object} owner - owner item
*
* @returns  {String} - a color-value as String
*/

import { colorCodes } from '../config/config'

const colorByOwnerType = (ownerCode) => {
  if (!isNaN(ownerCode)) {
    return colorCodes[ownerCode]
  }
  return 'none'
}

export default colorByOwnerType



// WEBPACK FOOTER //
// ./src/logic/colorByOwnerType.js